import { generateRequest } from '.';
import { compact } from '../../lib/utils';
import { toQueryString } from '../../lib/utils/querystring';

export const Action = {
  StationInfo: {
    StationInfoPending: 'StationInfo_PENDING',
    StationInfoCompleted: 'StationInfo_FULFILLED',
    StationInfoFailed: 'StationInfo_FAILED',
    StationSearchPending: 'StationSearch_PENDING',
    StationSearchCompleted: 'StationSearch_FULFILLED',
    StationSearchFailed: 'StationSearch_FAILED',
    BrandStationsPending: 'BrandStations_PENDING',
    BrandStationsCompleted: 'BrandStations_FULFILLED',
    BrandStationsFailed: 'BrandStations_FAILED',
  },
  Station: {
    OutageUpdatePending: 'StationOutageUpdate_PENDING',
    OutageUpdateCompleted: 'StationOutageUpdate_FULFILLED',
    OutageUpdateFailed: 'StationOutageUpdate_FAILED',
  },
};

export const fetchStationInfo = stationId => generateRequest({
  endpoint: `/assets-v2/api/stations/${stationId}/info`,
  types: [
    Action.StationInfo.StationInfoPending,
    Action.StationInfo.StationInfoCompleted,
    Action.StationInfo.StationInfoFailed,
  ],
});

export const fetchStationsByBrand = queryParams => generateRequest({
  endpoint: `/assets-v2/api/stations?${toQueryString(compact(queryParams))}`,
  types: [
    Action.StationInfo.BrandStationsPending,
    Action.StationInfo.BrandStationsCompleted,
    Action.StationInfo.BrandStationsFailed,
  ],
});

export const searchForStations = queryParams => generateRequest({
  endpoint: `/assets-v2/api/stations?${toQueryString(compact(queryParams))}`,
  types: [
    Action.StationInfo.StationSearchPending,
    Action.StationInfo.StationSearchCompleted,
    Action.StationInfo.StationSearchFailed,
  ],
});

export const updateStationStatus = body => generateRequest({
  method: 'POST',
  credentials: 'same-origin',
  endpoint: '/assets-v2/api/outages',
  body,
  types: [
    Action.Station.OutageUpdatePending,
    Action.Station.OutageUpdateCompleted,
    Action.Station.OutageUpdateFailed,
  ],
});
